export default {
  contract_id: "ID du contrat",
  unpaid: "Impayé",
  paid: "Payé",
  reception: "Réception",
  check_in: "Arrivée",
  check_out: "Départ",
  active: "Actif",
  passed: "Passé",
  expected: "Prévu",
  inactive: "Inactif",
  reception_today: "Réception aujourd’hui",
  checkin: {
    fill_in: "Entrez les détails du voyageur",
    type: "Type de client",
    private: "Privé",
    business: "Entreprise",
    company_name: "Nom de l'entreprise",
    company_vat: "Numéro de TVA",
    optional: "facultatif",
    company_po: "Numéro de PO",
    gender: "Sexe",
    first_name: "Prénom",
    last_name: "Nom de famille",
    street: "Rue",
    zip: "Code postal",
    phone_number: "Numéro de téléphone",
    email: "E-mail",
    country: "Pays",
    city: "Ville",
    continue: "Continuer",
    vat_hint: "Entrez votre numéro de TVA et quittez le champ pour le valider",
    validate_vat: "Valider la TVA",
    vat_verified: "TVA validée",
    vat_invalid: "Numéro de TVA invalide",
    vat_enter_valid: "Veuillez saisir un numéro de TVA valide",
    vat_verified_no_data_manual: "Le numéro de TVA est valide, mais aucune donnée d'entreprise n'a été renvoyée. Veuillez les compléter manuellement.",
    update_success: "Vos informations client et de contact ont été mises à jour avec succès.",
    update_guest_only_contact_sales: "Vos informations client ont été mises à jour, mais vos coordonnées n'ont pas pu être modifiées car des factures existent déjà. Veuillez contacter le service commercial si vos coordonnées doivent encore être mises à jour."


  },
  options: {
    options: "Options",
    select_additional: "Sélectionner des options supplémentaires",
    breakfast_select_dates: "Sélectionnez les dates du petit-déjeuner",
    total_price: "Prix total",
    guests: "Invités",
    nights: "Nuits",
    cancel: "Annuler",
    confirm: "Confirmer"
  },
  overview: {
    overview: "Aperçu",
    name: "Nom",
    address: "Adresse",
    phone: "Téléphone",
    email: "E-mail",
    invoice_lines: "Lignes de facture",
    removed_options: "Options supprimées",
    added_options: "Options nouvellement ajoutées",
    continue_pay_later: "Continuez et payez plus tard",
    contract: "Contrat",
    guest_info: "Informations sur l'invité",
    total_pay_today: "Total à payer aujourd'hui : ",
    confirm_and_pay: "Confirmer et payer maintenant",
    terms_and_conditions: "Conditions générales",
    accept_terms_and_conditions: "J'accepte les conditions générales",
    select_method: "Veuillez sélectionner un mode de paiement pour continuer.",
    accept_terms_required: "Vous devez accepter les conditions générales avant de continuer.",
    invoice_lines_due_today: "Montant à payer",
    paid_already: "Déjà payé",
    option_changes: "Modifications d’options",
    prepaid_balance_used: "Solde prépayé utilisé"
  },
  passport: {
    passport_scanner: "Scanner de passeport",
    legal_1: "En raison d'exigences légales, nous devons scanner votre passeport pour vérification.",
    legal_2: "Veuillez télécharger une image claire du côté contenant la zone lisible par machine (MRZ). Il se compose de deux ou trois lignes de chiffres, de lettres et de symboles. Ces informations sont cruciales pour l'authentification de votre passeport.",
    mrz_look_like: "A quoi ressemble une MRZ ?",
    mrz_example: "Exemple MRZ",
    close: "Fermer",
    upload_passport: "Télécharger le passeport",
    warning_overwrite: "Attention : le téléchargement d'un nouveau passeport écrasera votre passeport actuel.",
    rejected: "Votre passeport a été rejeté.",
    reason: "Raison: ",
    overwrite_passport: "Écraser le passeport",
    process_passport: "Traitement du passeport",
    passport_data: "Données du passeport",
    gender: "Genre",
    nationality : "Nationalité",
    first_name: "Prénom",
    last_name: "Nom de famille",
    is_data_correct: "Les données du passeport sont-elles correctes ?",
    yes: "oui",
    no: "non",
    password_approved: "Passeport approuvé",
    awaiting_approval: "En attente de contrôle manuel du passeport par l'équipe commerciale",
    failed_to_process: "Échec du traitement du passeport. Veuillez vous assurer que le MRZ est clairement visible.",
    passport_confirmation: "Confirmation du passeport",
    picture_correct: "L'image est correcte",
    correct_picture_wrong_data: "L'image que vous avez téléchargée est correcte mais les données sont mal lues : ",
    sales_team_manual_lookup: "notre équipe commerciale inspectera manuellement cette image et remplira les données correctes.",
    upload_new_picture: "Télécharger une nouvelle image",
    remove_picture_upload_new: "La photo actuelle sera supprimée et vous pourrez télécharger une nouvelle photo de passeport.",
    enter_now: "Je vais maintenant scanner mon passeport avec une photo.",
    enter_manually: "Je vais saisir les données de mon passeport manuellement.",
    provide_at_checkin: "Je fournirai mon passeport lors de l'enregistrement",
    provide_at_checkin_during_hours: "Je fournirai mon passeport pendant les heures de réception entre [checkin_time] et [checkout_time] lors de l'enregistrement.",
    enter_passport_data: "Saisissez les détails de votre passeport ou carte d'identité",
    birth_date: "Date de naissance",
    id_number: "Numéro du document",
    submit: "Soumettre",
    document_number_help_title: "Où trouver votre numéro de document",
    document_number_help_belgian_eid_label: "Carte d'identité belge (eID)",
    document_number_help_belgian_eid_text: "Le numéro du document se trouve à l’arrière de la carte dans la zone lisible par machine (MRZ). Cherchez la ligne commençant par IDBEL ; le numéro suit ce préfixe.",

    document_number_help_belgian_passport_label: "Passeport belge",
    document_number_help_belgian_passport_text: "Le numéro du document se trouve sur la page d'identité, généralement en haut à droite.",

    document_number_help_other_label: "Autres nationalités",
    document_number_help_other_text: "Le numéro du document se trouve généralement sur la page d'identité de votre passeport ou carte d'identité, et est libellé comme 'Numéro de document', 'Numéro de passeport' ou similaire.",
    ok: "OK"

  },
  key_pickup: {
    key_pickup_instructions: "Instructions pour la récupération des clés",
    gate_code: "Code de la porte : ",
    vault_code: "Code du coffre : ",
    check_in: "Vous pouvez vous enregistrer à notre réception ouverte le [arrival_date] entre [checkin_time] et [checkout_time]",
    late_arrival_notice: "Attention : Arrivée après [checkin_day] ou avez-vous réservé un enregistrement anticipé ?",
    follow_instructions: "Ensuite, suivez les instructions suivantes : ",
    access_entrance: "Pour accéder au hall d'entrée, entrez le code ",
    entrance_description: "Dans le hall d'entrée, vous verrez le coffre où vous trouverez la clé de votre chambre et quelques informations.",
    code_safe: "Le code de ce coffre est ",
    safe_instructions: "Tournez la serrure du coffre vers la droite pour ouvrir la porte/à gauche pour la refermer. ",
    inside_envelope_letter: "À l'intérieur, vous trouverez une enveloppe avec la lettre ",
    personal_envelope: ", ceci est votre enveloppe personnelle. ",
    inside_envelope: "À l'intérieur, vous trouverez une enveloppe avec ",
    your_name: "VOTRE NOM ",
    key_document_inside: "Votre clé avec le numéro de chambre et le document sont à l'intérieur de cette enveloppe, ainsi que les coordonnées. ",
    contact_residence: "En cas de difficulté, vous pouvez contacter le gérant de la résidence au numéro d'urgence suivant : ",
    complete_checkin_for_instructions: "Complétez votre enregistrement pour accéder à vos instructions de récupération de clé.",
    instructions_on_arrival_day: "Le jour de votre arrivée, vous trouverez ici vos instructions d'enregistrement.",
    show_qr: "Afficher le QR code"
  },
  qr_code: {
    title: "QR code de réservation",
    hint: "Utilisez ce QR code si nécessaire.",
    not_available: "QR code non disponible pour cette réservation.",
    load_failed: "Le QR code n’a pas pu être chargé."
  }


}
